module.exports = __webpack_public_path__ + "img/signpic.4313279d.png";